// extracted by mini-css-extract-plugin
export default {"section":"AboutMe_section__B1lKq","container":"AboutMe_container__QcWaX","text":"AboutMe_text__rMSrY"};